export const UNDERLYING_ASSETS = [
  { id: 'STOCK', displayValue: 'Stock' },
  { id: 'INDEX', displayValue: 'Index' },
  { id: 'CDS', displayValue: 'CDS' },
  { id: 'FX', displayValue: 'FX' },
  { id: 'BOND', displayValue: 'Bond' },
];
